var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.906 5.794A7.15 7.15 0 1 0 6.794 15.906l4.244 4.243a1.15 1.15 0 0 0 1.625 0l.187-.187.006-.006 4.05-4.05a7.15 7.15 0 0 0 0-10.112M5.592 4.592a8.85 8.85 0 0 1 12.516 12.516l-4.243 4.243a2.85 2.85 0 0 1-4.03 0l-4.243-4.243a8.85 8.85 0 0 1 0-12.516M11.85 8.7a2.15 2.15 0 1 0 0 4.3 2.15 2.15 0 0 0 0-4.3M8 10.85a3.85 3.85 0 1 1 7.7 0 3.85 3.85 0 0 1-7.7 0",
  clipRule: "evenodd"
})));
export default SvgLocationMarker;